{
  "v11.journal.acteur_inconnu": "acteur inconnu",
  "v11.journal.auteurs.createur": "Créateur ou demandeur : {{qui}}",
  "v11.journal.auteurs.decideur": "Décideur : {{qui}}",
  "v11.journal.auteurs.identites_distinctes": "Auteur et décideur sont deux personnes distinctes.",
  "v11.journal.auteurs.identites_identiques_signalees": "La même personne a créé et décidé : séparation des tâches non respectée.",
  "v11.journal.auteurs.inconnu": "non renseigné",
  "v11.journal.auteurs.information_historique_insuffisante": "Information historique insuffisante pour comparer auteur et décideur.",
  "v11.journal.auteurs.lecture_seule": "Lecture seule : aucune décision ne se prend depuis le journal.",
  "v11.journal.auteurs.non_applicable": "Aucune décision dans cet événement : auteurs et décideurs sans objet.",
  "v11.journal.auteurs.titre": "Auteurs et décideurs",
  "v11.journal.code.AUDIT_EXPORT_PERMISSION_REQUIRED": "Le journal de ce projet est réservé à son propriétaire et à l’administration de l’organisation.",
  "v11.journal.code.CONTEXTE_INCOMPLET": "Le contexte nécessaire à la vérification de vos droits est incomplet.",
  "v11.journal.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour consulter ce journal.",
  "v11.journal.code.JOURNAL_EXPORT_TROP_VOLUMINEUX": "Plus de 5 000 lignes : affinez les filtres avant d’exporter.",
  "v11.journal.code.RESOURCE_UNAVAILABLE": "Ce projet est introuvable dans votre organisation.",
  "v11.journal.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v11.journal.code.VALIDATION_ERROR": "Filtres refusés par le serveur : vérifiez le résultat et les dates.",
  "v11.journal.code.evenement.RESOURCE_UNAVAILABLE": "Cet événement est introuvable dans ce projet.",
  "v11.journal.code.evenement.VALIDATION_ERROR": "Identifiant d’événement mal formé.",
  "v11.journal.contexte.defaut": "Accès direct : le retour ouvre le journal du projet sans filtre.",
  "v11.journal.contexte.repris": "Filtres et position du journal repris : le retour vous ramène où vous étiez.",
  "v11.journal.contexte.titre": "Contexte de lecture",
  "v11.journal.etat.chargement": "Chargement {{quoi}}…",
  "v11.journal.etat.erreur": "Lecture impossible ({{quoi}}).",
  "v11.journal.etat.reessayer": "Réessayer",
  "v11.journal.etat.refus": "Lecture refusée ({{quoi}}).",
  "v11.journal.evenement.depend": "Dépend de la lecture de l’événement.",
  "v11.journal.evenement.identifiant": "Identifiant {{id}} · corrélation {{correlation}}",
  "v11.journal.evenement.immuable": "Un événement du journal ne se modifie ni ne se supprime.",
  "v11.journal.evenement.masques": "Source non accessible : titres et extraits masqués.",
  "v11.journal.evenement.qui_quoi": "{{acteur}} · {{action}} · {{cible}}",
  "v11.journal.evenement.quoi": "de l’événement",
  "v11.journal.evenement.resultat": "Résultat : {{resultat}}",
  "v11.journal.evenement.sans_correlation": "aucune",
  "v11.journal.evenement.titre": "Événement",
  "v11.journal.evenement.titre_ecran": "Détail d’un événement du projet",
  "v11.journal.export.annuler": "Annuler",
  "v11.journal.export.colonnes": "Colonnes : {{colonnes}}",
  "v11.journal.export.conservation": "Entrées conservées selon la politique de rétention ; {{plafond}} lignes au plus par export.",
  "v11.journal.export.conservation_partielle": "Historique partiel : aucune entrée conservée avant le {{date}}.",
  "v11.journal.export.depend": "Dépend de l’aperçu de l’export.",
  "v11.journal.export.echec": "L’export n’a pas abouti.",
  "v11.journal.export.en_cours": "Export en cours…",
  "v11.journal.export.ensemble": "Ensemble filtré depuis la première ligne, jamais la page affichée.",
  "v11.journal.export.exporter": "Exporter",
  "v11.journal.export.expurgations": "Valeurs expurgées : {{cles}}",
  "v11.journal.export.fait": "{{n}} lignes exportées ; l’export est consigné au journal.",
  "v11.journal.export.masques": "Sources non accessibles : leurs titres et extraits sont retirés de l’export.",
  "v11.journal.export.perimetre": "Projet {{projet}} · toute la période conservée · heures en UTC",
  "v11.journal.export.perimetre_periode": "Projet {{projet}} · du {{du}} au {{au}} · heures en UTC",
  "v11.journal.export.quoi": "de l’aperçu de l’export",
  "v11.journal.export.session_expiree": "Votre session a expiré : reconnectez-vous puis relancez l’export.",
  "v11.journal.export.titre": "Exporter le journal du projet",
  "v11.journal.export.trop_volumineux": "Plus de 5 000 lignes : affinez les filtres avant d’exporter.",
  "v11.journal.export.volume": "{{n}} lignes, format CSV, {{plafond}} lignes au plus.",
  "v11.journal.filtres.acteur": "Acteur",
  "v11.journal.filtres.action": "Action",
  "v11.journal.filtres.appliquer": "Appliquer les filtres",
  "v11.journal.filtres.au": "Au",
  "v11.journal.filtres.bornes": "Du (inclus) au (exclu), en UTC.",
  "v11.journal.filtres.correlation": "Corrélation",
  "v11.journal.filtres.dates_inversees": "La date de début doit précéder la date de fin.",
  "v11.journal.filtres.du": "Du",
  "v11.journal.filtres.objet_id": "Objet (identifiant)",
  "v11.journal.filtres.objet_type": "Objet (type)",
  "v11.journal.filtres.resultat": "Résultat",
  "v11.journal.filtres.titre": "Filtres",
  "v11.journal.habilitation.actuel_distinct": "Les habilitations actuelles se lisent dans les membres du projet : elles peuvent différer de l’état historique.",
  "v11.journal.habilitation.droit": "Droit examiné : {{droit}} · motif {{motif}}",
  "v11.journal.habilitation.non_applicable": "Aucune décision d’habilitation pour cet événement.",
  "v11.journal.habilitation.non_conserve": "Profil au moment de l’action : non conservé.",
  "v11.journal.habilitation.roles": "Rôles de session observés (rapprochement par acteur, route et instant, non certain) : {{roles}}",
  "v11.journal.habilitation.sans_observation": "Aucune observation d’habilitation rapprochée.",
  "v11.journal.habilitation.titre": "Habilitation observée",
  "v11.journal.journal.titre": "Journal d’audit du projet",
  "v11.journal.liens.acteur": "Fiche de l’acteur",
  "v11.journal.liens.chronologie": "Chronologie de l’objet",
  "v11.journal.liens.correles": "Événements corrélés",
  "v11.journal.liens.exporter": "Exporter le journal",
  "v11.journal.liens.exports_gouvernes": "Exports gouvernés du projet",
  "v11.journal.liens.exports_gouvernes_a_venir": "Écran livré avec la vague des exports.",
  "v11.journal.liens.habilitations_organisation": "Habilitations de l’organisation",
  "v11.journal.liens.journal_organisation": "Journal de l’organisation",
  "v11.journal.liens.membres": "Membres du projet",
  "v11.journal.liens.profil": "Profil de l’acteur",
  "v11.journal.liens.retour_journal": "Revenir au journal",
  "v11.journal.liens.retour_projet": "Revenir au projet",
  "v11.journal.liens.sans_acteur": "Acteur automatique : aucune fiche de personne.",
  "v11.journal.liens.sans_correlation": "Aucune corrélation pour cet événement.",
  "v11.journal.liens.sans_objet": "Cet événement ne vise aucun objet.",
  "v11.journal.liens.sans_profil": "Le profil au moment de l’action n’est pas conservé.",
  "v11.journal.ligne": "{{quand}} · {{acteur}} · {{action}} · {{cible}} · {{resultat}}",
  "v11.journal.liste.examiner": "Examiner {{action}}",
  "v11.journal.liste.fin": "Fin du journal.",
  "v11.journal.liste.masques": "Certaines sources ne vous sont pas accessibles : leurs titres et extraits sont masqués.",
  "v11.journal.liste.ordre": "Du plus récent au plus ancien.",
  "v11.journal.liste.position": "Lignes {{de}} à {{a}} sur {{total}}",
  "v11.journal.liste.quoi": "du journal",
  "v11.journal.liste.suivante": "Page suivante",
  "v11.journal.liste.titre": "Événements du journal",
  "v11.journal.liste.vide": "Aucun événement pour ces filtres.",
  "v11.journal.perimetre.historique_partiel": "Historique partiel : aucune entrée conservée avant le {{date}}.",
  "v11.journal.perimetre.modele": "Modèle « {{libelle}} », version {{version}}",
  "v11.journal.perimetre.projet": "Projet {{projet}} · heures en UTC",
  "v11.journal.perimetre.sans_modele": "Aucun modèle figé pour ce projet.",
  "v11.journal.perimetre.titre": "Périmètre",
  "v11.journal.preuves.absente": "Aucune empreinte pour cette ligne d’audit : preuve absente.",
  "v11.journal.preuves.empreinte": "Empreinte {{empreinte}} ({{algo}}) · clé {{cle}}, {{statut}}",
  "v11.journal.preuves.expurge": "Contenu sensible expurgé.",
  "v11.journal.preuves.non_attestee": "Intégrité non attestée ici : l’attestation de la chaîne passe par l’export d’audit vérifiable.",
  "v11.journal.preuves.titre": "Preuves",
  "v11.journal.reference.source_hors_modele": "Type et identifiant historiques : {{objet}} (hors modèle d’éléments).",
  "v11.journal.reference.source_presente": "Type et identifiant historiques : {{objet}}.",
  "v11.journal.reference.source_supprimee": "Type et identifiant historiques : {{objet}}.",
  "v11.journal.reference.titre": "Titre : {{titre}}",
  "v11.journal.reference.titre_section": "Source historique",
  "v11.journal.reference.trace_conservee": "Source supprimée depuis : la trace de l’événement est conservée.",
  "v11.journal.resultat.echec": "Échec",
  "v11.journal.resultat.refus": "Refus",
  "v11.journal.resultat.succes": "Succès",
  "v11.journal.resultat.tous": "Tous",
  "v11.journal.sans_evenement": "Choisissez un événement depuis le journal du projet.",
  "v11.journal.sans_projet": "Choisissez un projet pour lire son journal d’audit.",
  "v11.journal.source.element": "{{titre}} · statut {{statut}}",
  "v11.journal.source.ouvrir": "Ouvrir la source",
  "v11.journal.source.quoi": "de la source",
  "v11.journal.source.vide": "Source vide."
}
